<template>
  <div v-if="!emptyData">
    <div class="gift disFlex vertical" v-if="pageType===0">
      <div class="like-info disFlex fvc vertical">
        <div>
          <div class="gift-img disFlex fvc fc">
            <img :src="likeInfo.img" class="img" />
          </div>
          <div class="gift-title">{{likeInfo.prizeName}}</div>
          <div class="gift-info">{{likeInfo.rule}}</div>
        </div>
      </div>
      <!-- 成功了则为二维码 -->
      <!-- <div v-if="likeInfo.status==='success'&&self" class="f fvc">
        <img :src="qrcode" class="gift-qrcode" />
      </div>-->

      <!-- "自己"的集赞进度 -->
      <div v-if="self">
        <div
          class="interact-progress f v fvc"
        >互动完成进度： {{likeInfo.helpUser?likeInfo.helpUser.length:0}} / {{likeInfo.assist}}</div>
        <div class="interact-data f fvc v">参与人数{{likeInfo.num}}人 ，剩余{{likeInfo.stock}}份</div>

        <!-- <div class="interact-status f fvc v">待互动</div> -->
        <div
          class="helpers-box f fvc Flex-wrap"
          v-if="likeInfo.helpUser&&likeInfo.helpUser.length>=0"
        >
          <div class="helper-item f v fvc" v-for="(item,idx) in likeInfo.helpUser" :key="idx">
            <img :src="item.avatar" class="user-avatar" />
            <div class="nickname">{{item.nickname}}</div>
          </div>
        </div>
      </div>

      <!-- "好友"的集赞进度 -->
      <div v-if="!self" class="friend-interact f fvc v">
        <div class="interact-data">参与人数{{likeInfo.num}}人 ，剩余{{likeInfo.stock}}份</div>
        <div class="friend-box f v fvc">
          <div v-if="likeInfo.sharer" class="friend-info f fc">
            <img src="https://j.weizan.cn/youxiang/haoyou.png" class="haoyou" />
            <div class="friend-name">{{likeInfo.sharer.nickname}}</div>
            <img src="https://j.weizan.cn/youxiang/like-tip.png" class="like-tip" />
          </div>
          <div
            class="interact-progress f v fvc"
          >互动完成进度： {{likeInfo.helpUser?likeInfo.helpUser.length:0}} / {{likeInfo.assist}}</div>
          <div
            class="helpers-box f fvc Flex-wrap"
            v-if="likeInfo.helpUser&&likeInfo.helpUser.length>0"
          >
            <div class="helper-item f v fvc" v-for="(item,idx) in likeInfo.helpUser" :key="idx">
              <img :src="item.avatar" class="user-avatar" />
              <div class="nickname">{{item.nickname}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-box f fvc v">
        <div class="page-btn get-btn" v-if="likeInfo.status==='no_start'" @click="freeGet">我要免费领取</div>
        <div
          class="page-btn get-btn"
          v-if="likeInfo.status==='sharing'&&self"
          @click="alertTip"
        >集赞任务开始</div>
        <div
          class="page-btn get-btn"
          v-else-if="!self&&!likeInfo.helpStatus"
          @click="helpFriend"
        >帮好友集赞</div>
        <div
          class="page-btn get-btn"
          v-else-if="(likeInfo.status==='sharing'||likeInfo.status==='success')&&!self&&likeInfo.helpStatus"
          @click="wantLike"
        >我也要集赞</div>
        <div
          class="page-btn get-btn"
          v-else-if="likeInfo.status==='success'&&self"
          @click="goCheck"
        >去核销</div>
        <div
          class="page-btn get-btn"
          v-else-if="likeInfo.status==='applied'&&self"
          @click="viewChecked"
        >已核销</div>

        <div class="page-btn back-btn" @click="backHome">返回首页</div>
      </div>
      <van-dialog v-model="qrcodeFlag" :close-on-click-overlay="true" :show-confirm-button="false">
        <div style="width:80%;margin:10px auto">
          <img :src="qrcode" style="width:100%" alt="图片加载中，请稍后" />
          <div class="tip">出示给导购员进行扫码核销</div>
        </div>
      </van-dialog>
      <div v-if="actSignupFlag">
        <act-signup
          @closeSignup="closeSignup"
          @signupSuccess="signupSuccess"
          :enrollNum="enrollNum"
        ></act-signup>
      </div>
    </div>
    <div v-else-if="pageType===1" class="f fvc v">
      <img src="https://j.weizan.cn/youxiang/check-success.png" class="status-img" />
      <div class="check-status">已核销</div>
      <div class="check-info">奖品名称：{{likeInfo.prizeName}}</div>
      <div class="check-info">核销导购员：{{likeInfo.kpiUserName}}</div>
      <div class="check-info">核销品牌：{{likeInfo.kpiUserBrand||'-'}}</div>
      <div class="check-info">核销门店：{{likeInfo.kpiUserShop||'-'}}</div>
      <div class="check-info">核销时间：{{likeInfo.finishTime}}</div>
    </div>
  </div>
  <div v-else class="empty-page f fvc v fc">
    <img src="https://j.weizan.cn/youxiang/empty-data.png" class="empty-img" />
    <div class="tip">暂无数据</div>
  </div>
</template>

<script>
import ActSignup from "./../../components/act-signup";
import { mapState } from "vuex";

export default {
  components: {
    ActSignup,
  },
  data() {
    return {
      pageType: 0, // 1为核销页面
      //no_start=未参加,sharing=进度,success=集赞成功,applied=已核销,finish=活动已结束
      // giftStatus: 0, //0未领取 1未核销 2成功 3未成功
      likeInfo: {},
      qrcode: "",
      friendShare: this.$route.query.fh || false, //是否好友邀请
      self: this.$route.query.self || false, // 是否正常跳转过来的自己的页面
      qrcodeFlag: false,
      actSignupFlag: false,
      emptyData: false,
      enrollStatus: localStorage.getItem("setEnrollStatus"),
    };
  },
  created() {
    this.$initWXSDK(
      {
        openShare: true,
      },
      () => {
        this.$utils.getLocation().then((res) => {});
      },
      {}
    );
    if (this.$route?.query?.share_user_id === localStorage.getItem("user_id")) {
      this.self = true;
    }
    this.$store.commit("setLoading", true);

    this.getLikeInfo();
  },
  computed: {
    // ...mapState(["enrollStatus"]),
  },
  methods: {
    closeSignup() {
      this.actSignupFlag = false;
    },
    viewChecked() {
      if (this.self) {
        this.pageType = 1;
      }
    },
    goCheck() {
      this.getQrCode().then(() => {
        this.qrcodeFlag = true;
      });
    },
    getQrCode() {
      return new Promise((resolve) => {
        this.$http
          .get("/v1/qrcode/gen_code", {
            scene: "collect_likes_finish",
            addition: encodeURIComponent(
              JSON.stringify({ id: this.likeInfo.collectFinishId })
            ),
          })
          .then((res) => {
            if (res.code === 0) {
              this.qrcode = res.data.qrcodePath;
              resolve();
            }
          });
      });
    },
    freeGet() {
      if (this.likeInfo.enrollmentFlag) {
        this.$utils.checkEnroll().then(() => {
          if (this.enrollStatus !== "enrolled") {
            this.actSignupFlag = true;
            return false;
          }
        });
      }
      this.startLikeAct();
    },
    wantLike() {
      // enrollmentFlag 此集赞是否需要报名
      if (this.likeInfo.enrollmentFlag) {
        this.$utils.checkEnroll().then(() => {
          if (this.enrollStatus !== "enrolled") {
            this.actSignupFlag = true;
            return false;
          }
        });
      }
      // helperStatus  助力者是否有参加集赞活动
      if (this.likeInfo.helperStatus) {
        this.self = true;
        this.likeInfo.helpUser = [];
        this.getLikeInfo();
      } else {
        this.startLikeAct();
      }
    },
    signupSuccess() {
      this.self = true;
      this.startLikeAct();
    },
    helpFriend() {
      this.$txLogs({
        bpm: "3.collect_likes_help_friend",
      });
      this.$http.post("/v1/home/collect_like/help").then((res) => {
        if (res.code === 0) {
          this.getLikeInfo();
        }
      });
    },
    alertTip() {
      this.$dialog.alert({
        message: `你已经领取过该任务，快去和好友互动吧！`,
        confirmButtonText: "确认",
      });
    },
    startLikeAct() {
      if (localStorage.getItem("userType") !== "cus") {
        this.$dialog.alert({
          message: `导购员不能参加活动`,
          confirmButtonText: "确认",
        });
        return false;
      }
      this.$http.post("/v1/home/collect_like/start").then((res) => {
        if (res.code === 0) {
          this.self = true;
          this.getLikeInfo();
        }
      });
    },
    async getLikeInfo() {
      let info = await this.$http.post("/v1/home/collect_like/", {
        self: this.self ? true : false,
        showHelp: true,
      });
      if (info.code === 10200) {
        this.$store.commit("setLoading", false);
        return (this.emptyData = true);
      }
      if (info.code === 0) {
        this.likeInfo = info.data;

        if (this.likeInfo.status === "success" && this.self) {
          this.getQrCode();
        } else if (this.likeInfo.status === "applied" && this.self) {
          this.viewChecked();
        }
      }
      this.$store.commit("setLoading", false);
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.gift {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  .like-info {
    margin-top: 40px;
  }
  .gift-img {
    width: 116px;
    height: 116px;
    background: rgba(239, 239, 239, 1);
    border: 3px solid rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 28px 12px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    margin: 0 auto 20px;
    .img {
      width: 110px;
      height: 110px;
      border-radius: 12px;
    }
  }
  .gift-qrcode {
    width: 150px;
    height: 150px;
    background: rgba(208, 208, 208, 1);
    margin-top: 102px;
  }
  .btn-box {
    width: 100%;
    background: #fff;
  }
  .page-btn {
    width: 325px;
    height: 44px;
    background: rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 44px;
    text-align: center;
    margin: 10px auto;
  }
  .back-btn {
    width: 325px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    line-height: 44px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    text-align: center;
    background: #fff;
  }
  .gift-title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    text-align: center;
    margin-bottom: 15px;
  }
  .gift-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(116, 116, 116, 1);
    text-align: center;
    margin: 0 33px;
    line-height: 24px;
  }
  .interact-progress {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    margin: 30px 0 15px;
  }
  .nickname,
  .interact-status {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(244, 0, 0, 1);
    margin-top: 10px;
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-top: 20px;
  }
  .status-img {
    width: 88px;
    height: 88px;
  }
  .check-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 24px;
  }
  .check-status {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    text-align: center;
    margin: 20px 0 40px;
  }
  .check-btn {
    width: 215px;
    height: 50px;
    background: rgba(0, 48, 120, 1);
    border-radius: 25px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    margin: 50px 0 28px;
  }
  .record {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
  .helpers-box {
    min-height: 44px;
    max-height: 150px;
    overflow-y: scroll;
    .helper-item {
      min-width: 60px;
      height: 85px;
    }
  }
  .friend-interact {
    .interact-data {
      height: 33px;
      background: rgba(0, 48, 120, 0.1);
      border-radius: 2px;
      margin: 20px auto;
      padding: 0 20px;
      line-height: 33px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
    }
    .friend-box {
      width: 100%;
      background: linear-gradient(
        rgba(0, 48, 120, 0.08),
        rgba(255, 255, 255, 0.08)
      );
      border-radius: 16px 16px 0px 0px;
      .friend-info {
        margin-top: 28px;
      }
      .haoyou {
        width: 33px;
        height: 13px;
      }
      .like-tip {
        width: 99px;
        height: 13px;
      }

      .friend-name {
        height: 20px;
        background: rgba(0, 48, 120, 0.2);
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(18, 61, 125, 1);
        line-height: 20px;
        padding: 0 7px;
        margin: 0 7px;
      }
      .interact-progress {
        margin: 20px 0;
      }
    }
  }
}
.status-img {
  width: 88px;
  height: 88px;
  margin-top: 80px;
}
.check-info {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  line-height: 24px;
}
.check-status {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
  text-align: center;
  margin: 20px 0 40px;
}
.empty-page {
  height: 100vh;
  .tip {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(116, 116, 116, 1);
  }
  .empty-img {
    width: 74px;
    height: 119px;
  }
}
</style>